import React, { useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Main from '../layouts/Main';
import { useApi } from '../contexts/Api';
import VolumeDiscountList from '../components/VolumeDiscountList';
import AddVolumeDiscountDialog from '../components/AddVolumeDiscountDialog';
import EditVolumeDiscountDialog from '../components/EditVolumeDiscountDialog';

const VolumeDiscounts = () => {
  const { volumeDiscounts, loadingVolumeDiscounts, fetchVolumeDiscounts } = useApi();
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedRule, setSelectedRule] = useState(null);

  const handleAddClick = () => setAddDialogOpen(true);

  const handleEditClick = (rule) => {
    setSelectedRule(rule);
    setEditDialogOpen(true);
  };

  const handleCloseDialogs = () => {
    setAddDialogOpen(false);
    setEditDialogOpen(false);
    setSelectedRule(null);
  };

  const handleAddSave = async () => {
    setAddDialogOpen(false);
    await fetchVolumeDiscounts();
  };

  const handleEditSave = async () => {
    setEditDialogOpen(false);
    setSelectedRule(null);
    await fetchVolumeDiscounts();
  };

  return (
    <Main>
      <div className="page-header">
        <div>
          <h1 className="page-title">Volume Discounts</h1>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Volume Discounts</li>
          </ol>
        </div>
        <div className="page-header-actions">
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddClick}
            sx={{
              backgroundColor: '#845adf',
              '&:hover': { backgroundColor: '#6c48c5' }
            }}
          >
            Add Rule
          </Button>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card custom-card">
            <div className="card-header">
              <div className="card-title">All Volume Discount Rules</div>
            </div>
            <div className="card-body">
              {loadingVolumeDiscounts ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                  <CircularProgress />
                </Box>
              ) : volumeDiscounts && volumeDiscounts.length > 0 ? (
                <VolumeDiscountList
                  rules={volumeDiscounts}
                  onEdit={handleEditClick}
                  onRefresh={fetchVolumeDiscounts}
                />
              ) : (
                <Box textAlign="center" py={5}>
                  <Typography variant="h6" color="text.secondary">
                    No volume discount rules yet. Create your first rule to offer tiered pricing!
                  </Typography>
                </Box>
              )}
            </div>
          </div>
        </div>
      </div>

      <AddVolumeDiscountDialog
        open={addDialogOpen}
        onClose={handleCloseDialogs}
        onSave={handleAddSave}
      />

      <EditVolumeDiscountDialog
        open={editDialogOpen}
        onClose={handleCloseDialogs}
        rule={selectedRule}
        onSave={handleEditSave}
      />
    </Main>
  );
};

export default VolumeDiscounts;
